import { addMessages } from '@hana/i18n';

// Khoá chuỗi của chi tiết hoá đơn (InvoiceDetail.tsx). Dữ liệu mẫu (tên khách, trạng thái, bước, nhật ký) và mã nghiệp vụ không dịch.
addMessages('vi', {
  'ivdt.tab.lines': 'Dòng HĐ', 'ivdt.tab.rel': 'Debit / job liên quan', 'ivdt.tab.pay': 'Thanh toán', 'ivdt.tab.log': 'Lịch sử',
  'ivdt.noWrite': 'Chưa mở ghi ở bản này', 'ivdt.menuSoon': 'Menu thao tác chưa mở ở bản này',
  'ivdt.back': 'Quay lại danh sách hoá đơn', 'ivdt.backTip': 'Danh sách hoá đơn', 'ivdt.tabsAria': 'Mục của hoá đơn',
  'ivdt.more': 'Thao tác khác',
  'ivdt.linesSec': 'Dòng hoá đơn',
  'ivdt.h.code': 'Mã', 'ivdt.h.desc': 'Diễn giải', 'ivdt.h.qty': 'SL', 'ivdt.h.price': 'Đơn giá', 'ivdt.h.vat': 'VAT', 'ivdt.h.amt': 'Thành tiền',
  'ivdt.chTip': 'Chi hộ · chứng từ riêng, không VAT', 'ivdt.chPort': 'Chi hộ cảng',
  'ivdt.net': 'Tiền hàng', 'ivdt.tax': 'Thuế GTGT', 'ivdt.ch': 'Chi hộ', 'ivdt.total': 'Tổng thanh toán',
  'ivdt.jobAria': 'Job {job}',
  'ivdt.vsl': 'Tàu', 'ivdt.jst': 'Trạng thái job',
  'ivdt.recon': 'Đối soát phí job và debit', 'ivdt.jobFee': 'Phí bán job', 'ivdt.onDebit': 'Trên debit',
  'ivdt.demTip': 'Phí phát sinh sau khi debit đã khoá · tạo debit bổ sung, không sửa debit gốc', 'ivdt.dem': 'Phí mới · DEM 2 ngày chưa lên debit',
  'ivdt.match': 'Khớp hoàn toàn',
  'ivdt.noPay': 'Chưa phát hành hoá đơn nên chưa có thanh toán',
  'ivdt.prog': 'Tiến độ thu', 'ivdt.paidPct': 'Đã thu {p}%', 'ivdt.paidLow': 'đã thu', 'ivdt.remain': 'Còn phải thu',
  'ivdt.rcp': 'Phiếu thu', 'ivdt.noRcp': 'Chưa có phiếu thu',
  'ivdt.log': 'Lịch sử',
  'ivdt.sum': 'Tổng hợp', 'ivdt.paid': 'Đã thu', 'ivdt.due': 'Hạn thu', 'ivdt.dueIssue': 'Hạn phát hành', 'ivdt.paidDone': 'Đã thu',
  'ivdt.overDays': 'Quá {n} ngày', 'ivdt.days': '{n} ngày', 'ivdt.wdays': '{n} ngày LV',
  'ivdt.steps': 'Các bước',
  'ivdt.overMsg': 'Quá hạn thu {n} ngày · còn {v}', 'ivdt.lockMsg': 'Kỳ {per} đã khoá — chỉ sửa bằng HĐ điều chỉnh / thay thế ở kỳ mở',
});
addMessages('en', {
  'ivdt.tab.lines': 'Invoice lines', 'ivdt.tab.rel': 'Related debits / job', 'ivdt.tab.pay': 'Payments', 'ivdt.tab.log': 'History',
  'ivdt.noWrite': 'Writing is not enabled in this version', 'ivdt.menuSoon': 'Action menu is not enabled in this version',
  'ivdt.back': 'Back to invoice list', 'ivdt.backTip': 'Invoice list', 'ivdt.tabsAria': 'Invoice sections',
  'ivdt.more': 'More actions',
  'ivdt.linesSec': 'Invoice lines',
  'ivdt.h.code': 'Code', 'ivdt.h.desc': 'Description', 'ivdt.h.qty': 'Qty', 'ivdt.h.price': 'Unit price', 'ivdt.h.vat': 'VAT', 'ivdt.h.amt': 'Amount',
  'ivdt.chTip': 'Disbursement · separate document, no VAT', 'ivdt.chPort': 'Port disbursement',
  'ivdt.net': 'Net amount', 'ivdt.tax': 'VAT', 'ivdt.ch': 'Disbursements', 'ivdt.total': 'Total payable',
  'ivdt.jobAria': 'Job {job}',
  'ivdt.vsl': 'Vessel', 'ivdt.jst': 'Job status',
  'ivdt.recon': 'Job fee vs debit reconciliation', 'ivdt.jobFee': 'Job selling fee', 'ivdt.onDebit': 'On debit',
  'ivdt.demTip': 'Fee incurred after the debit was locked · create a supplementary debit, do not edit the original', 'ivdt.dem': 'New fee · DEM 2 days not yet on debit',
  'ivdt.match': 'Fully matched',
  'ivdt.noPay': 'Invoice not issued yet, so no payments',
  'ivdt.prog': 'Collection progress', 'ivdt.paidPct': 'Collected {p}%', 'ivdt.paidLow': 'collected', 'ivdt.remain': 'Outstanding',
  'ivdt.rcp': 'Receipts', 'ivdt.noRcp': 'No receipts yet',
  'ivdt.log': 'History',
  'ivdt.sum': 'Summary', 'ivdt.paid': 'Collected', 'ivdt.due': 'Due date', 'ivdt.dueIssue': 'Issue deadline', 'ivdt.paidDone': 'Collected',
  'ivdt.overDays': '{n} days overdue', 'ivdt.days': '{n} days', 'ivdt.wdays': '{n} working days',
  'ivdt.steps': 'Steps',
  'ivdt.overMsg': 'Overdue {n} days · {v} outstanding', 'ivdt.lockMsg': 'Period {per} is locked — only an adjustment / replacement invoice in an open period can change it',
});
